import {
  AppBar,
  Button,
  Checkbox,
  Container,
  FormControlLabel,
  FormGroup,
  Hidden,
  TextField,
  Toolbar,
  IconButton,
  Typography,
  CircularProgress,
  LinearProgress,
  Paper
} from "@material-ui/core";
import { Close } from "@material-ui/icons";
import React from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { useAuth } from "../contexts/AuthContext";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import Dialog from "@material-ui/core/Dialog";
import Slide from "@material-ui/core/Slide";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { useAddChatDialog } from "../contexts/AddChatDialogContext";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { useSnackbar } from "notistack";
import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/storage";
import { useDropzone } from "react-dropzone";
import { nanoid } from "nanoid";
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
    padding: "10px",
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: "25ch",
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export function AddChatDialog({ open }) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const { currentUser } = useAuth();
  const { enqueueSnackbar } = useSnackbar();
  const [participents, setParticipents] = React.useState([]);
  const [isGroup, setGroup] = React.useState(true);
  const [chatName, setChatName] = React.useState("");
  const { setDialogOpen } = useAddChatDialog();
  const [options, setOptions] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [progress, setProgress] = React.useState(null);
  const [files, setFiles] = React.useState([]);
  const classes = useStyles();
  const db = firebase.firestore();
  const storage = firebase.storage();
  const thumbsContainer = {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    marginTop: 16,
  };

  const thumb = {
    display: "inline-flex",
    borderRadius: 2,
    border: "1px solid #eaeaea",
    marginBottom: 8,
    marginRight: 8,
    width: 100,
    height: 100,
    padding: 4,
    boxSizing: "border-box",
  };

  const thumbInner = {
    display: "flex",
    minWidth: 0,
    overflow: "hidden",
  };

  const img = {
    display: "block",
    width: "auto",
    height: "100%",
  };

  const { getInputProps, getRootProps, acceptedFiles} = useDropzone({
    multiple: false,
    maxFiles: 1,
    maxSize: 6291456, // 6 MB,
    accept: "image/*",
    onDrop: (acceptedFiles) => {
      setFiles(
        acceptedFiles.map((file) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          })
        )
      );
    },
  });


  function createChatRoom() {
    setLoading(true);
    const storageRef = storage.ref();

    acceptedFiles.forEach((file) => {
      const usercontentRef = storageRef.child("rooms").child(nanoid());
      const uploadTask = usercontentRef.put(file);
      uploadTask.on(
        firebase.storage.TaskEvent.STATE_CHANGED,
        (snapshot) => {
          let progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          setProgress(progress);
        },
        null,
        () => {
          uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
            setProgress(null);
            addChat(downloadURL);
          });
        }
      );
    });
  }

  function addChat(url) {
    let members = [];
    participents.forEach((user) => {
      members.push(user.uid);
    });
    db.collection("rooms")
      .add({
        name: isGroup ? chatName : options[0].displayName,
        participents: [...members, currentUser.uid],
        photoURL: url,
        isGroup: isGroup,
        createdAt: firebase.firestore.FieldValue.serverTimestamp(),
      })
      .then((doc) => {
        // uploadFile(doc.id)
        doc.update({ roomID: doc.id });
      })
      .then(() => {
        setChatName("");
        setParticipents([]);
        setLoading(false);
        setDialogOpen(false);

        enqueueSnackbar("Chat created successfully!", {
          variant: "success",
          anchorOrigin: {
            vertical: "top",
            horizontal: "center",
          }
        });
      })
      .catch((error) => {
        enqueueSnackbar("Sorry couldn't create chat room", {
          variant: "error",
          anchorOrigin: {
            vertical: "top",
            horizontal: "center",
          }
        });
        setChatName("");
        setParticipents([]);
        setLoading(false);
        setDialogOpen(false);
      });
  }

  const fetchParticipents = (email) => {
    db.collection("users")
      .where("email", "==", email.trim())
      .where("email", "!=", currentUser.email)
      .get()
      .then((querySnapshot) => {
        const participents = [];
        querySnapshot.forEach((doc) => {
          participents.push(doc.data());
          setOptions([...options, doc.data()]);
        });
      });
    return participents;
  };

  const thumbs = files.map((file) => (
    <div style={thumb} key={file.name}>
      <div style={thumbInner}>
        <img src={file.preview} style={img} />
      </div>
    </div>
  ));

  return (
    <Dialog
      fullScreen={fullScreen}
      fullWidth={true}
      maxWidth="sm"
      open={open}
      TransitionComponent={Transition}
    >
      <DialogTitle id="confirmation-dialog-title">
        <Hidden smDown>Add a new chat</Hidden>
        <Hidden smUp>
          <AppBar position="fixed" color="secondary">
            <Toolbar>
              <Typography style={{ flex: 1 }} variant="h6">
                Add a new chat
              </Typography>
              <IconButton
                style={{ color: "white" }}
                onClick={() => setDialogOpen(false)}
                edge="end"
              >
                <Close />
              </IconButton>
            </Toolbar>
          </AppBar>
        </Hidden>
      </DialogTitle>
      <DialogContent dividers>
        {(progress !== null || progress === 100)? (
          <div>
            <Typography variant="caption">Uploading image please wait...</Typography>
            <LinearProgress variant="determinate" value={progress} />
          </div>
          
        ) : (
          ""
        )}
        <Container style={fullScreen ? { marginTop: "30px" } : null}>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  disabled
                  checked={true}
                  color="secondary"
                  onClick={(e) => setGroup(e.target.checked)}
                />
              }
              label="make this chat room as a group"
            />
            {isGroup ? (
              <TextField
                style={{ marginBottom: "20px" }}
                autoComplete="off"
                className={classes.textField}
                value={chatName}
                variant="outlined"
                placeholder="give a chat name"
                label="Group name"
                onChange={(e) => setChatName(e.target.value)}
              />
            ) : (
              ""
            )}
            <Autocomplete
              multiple
              id="tags-standard"
              options={options}
              getOptionLabel={(user) => user.email}
              onChange={(e, value) => setParticipents(value)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  helperText="enter full email id of people you wanna add to this chat room."
                  onChange={(e) => fetchParticipents(e.target.value)}
                  variant="outlined"
                  label="Add participents"
                  placeholder="Emails"
                />
              )}
            />
            <Paper style={{marginTop: "20px", backgroundColor: "beige"}} variant="outlined" className="container">
              <Container {...getRootProps({ className: "dropzone" })}>
                <input {...getInputProps()} />
                <Typography variant="subtitle1">+ Add a Room Icon</Typography>
                <Typography variant="caption" >Drag 'n' drop image here, or click to select file</Typography>
              </Container>
              <aside style={thumbsContainer}>{thumbs}</aside>
            </Paper>
            <Hidden smUp>
              <Button
                style={{ marginTop: "20px" }}
                variant="contained"
                color="secondary"
                onClick={createChatRoom}
              >
                {loading ? (
                  <CircularProgress style={{ color: "white" }} />
                ) : (
                  "Add"
                )}
              </Button>
            </Hidden>
          </FormGroup>
        </Container>
      </DialogContent>
      <Hidden smDown>
        <DialogActions>
          <Button
            variant="text"
            color="default"
            onClick={() => setDialogOpen(false)}
          >
            cancel
          </Button>
          <Button
            variant="contained"
            size="large"
            color="secondary"
            onClick={createChatRoom}
          >
            {loading ? <CircularProgress style={{ color: "white" }} /> : "Add"}
          </Button>
        </DialogActions>
      </Hidden>
    </Dialog>
  );
}
